import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ClimaCheckService from '~/api/services/climaCheck'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface Props {
  deleteData: any
  handleClose: (submit?: boolean) => void
}

const DeleteModal: React.FC<Props> = (props) => {
  const { deleteData, handleClose } = props
  const { t } = useTranslation()

  const [isBusy, setIsBusy] = useState(false)

  async function handleDelete() {
    setIsBusy(true)
    try {
      await ClimaCheckService.deleteClimaCheck(deleteData?.id)
      notify(t('Successfully delete climate check'), 'success')
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(deleteData)}
    handleClose={() => handleClose()}
    textHeader={t('Delete survey')}
    textContent={t('Do you really want to delete survey {{title}}?', { title: deleteData?.title })}
    textSubmit={t('Delete')}
    isLoading={isBusy}
    textClose={t('Close')}
    type={'abort'}
    handleSubmit={() => handleDelete()}
  />
}
export default DeleteModal